import About from "../../pages/About/About";
import Home from "../../pages/Home/Home";
import Projects from "../../pages/Projects/Projects";
import Skills from "../../pages/Skills/Skills";

const Layout = () => {
  return (
    <main>
      <Home />
      <About />
      <Skills />
      <Projects />
    </main>
  );
};

export default Layout;
